/* eslint-disable react-hooks/exhaustive-deps */
import _debounce from "lodash.debounce";
import * as React from "react";

export default function useDebouncedMemo(factory, deps, debounce) {
  const [state, setState] = React.useState(factory());

  const debouncedSetState = React.useCallback(
    _debounce(setState, debounce),
    []
  );

  React.useEffect(() => {
    debouncedSetState(factory());
  }, deps);

  return state;
}
